import { BASE_URL } from "../constants/constants";


const { io } = require("socket.io-client");

// Configure Socket.IO client with proper options
// Note: WebSocket may fail due to server configuration, but polling will work as fallback
export const IOSOCKETCLIENT = io(BASE_URL, {
  // Use polling first as it's more reliable across different network configurations
  // WebSocket will be attempted as an upgrade, but if it fails, polling continues to work
  transports: ['polling', 'websocket'],
  upgrade: true,
  rememberUpgrade: false, // Don't remember failed WebSocket upgrades
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 5,
  timeout: 20000,
  forceNew: false,
  withCredentials: false, // Don't use credentials for WebSocket to avoid CORS issues
  // Suppress WebSocket upgrade errors - they're expected if server doesn't support it
  autoConnect: true,
});

// Add comprehensive error handling and logging
IOSOCKETCLIENT.on('connect_error', (error) => {
  // Only log if it's not a WebSocket upgrade error (which is expected)
  if (!error.message?.includes('websocket') && !error.message?.includes('WebSocket')) {
    console.warn('Socket.IO connection error:', error.message);
  }
  // Connection will retry automatically via polling
});

IOSOCKETCLIENT.on('connect', () => {
  const transport = IOSOCKETCLIENT.io.engine.transport.name;
  console.log(`Socket.IO connected successfully via ${transport}`);
});

IOSOCKETCLIENT.on('disconnect', (reason) => {
  // Only log unexpected disconnections
  if (reason !== 'io client disconnect') {
    console.log('Socket.IO disconnected:', reason);
  }
});

// Handle transport upgrades (polling -> websocket)
IOSOCKETCLIENT.io.engine.on('upgrade', () => {
  const transport = IOSOCKETCLIENT.io.engine.transport.name;
  console.log(`Socket.IO upgraded to ${transport}`);
});

// Handle upgrade errors silently (WebSocket may not be available)
IOSOCKETCLIENT.io.engine.on('upgradeError', (error) => {
  // Silently fall back to polling - this is expected behavior
  // The connection will continue to work via polling
});

export const setIOSocketListeners = (channel, socket_channel, listenerCallBacks) => {
  if (channel) {
      if (IOSOCKETCLIENT.hasListeners(socket_channel)) {
          IOSOCKETCLIENT.off(socket_channel);
      }

      IOSOCKETCLIENT.emit('JOINLEAVEROOM', { action: 'join', channel });


      IOSOCKETCLIENT.on(socket_channel, (data) => {
          console.log('Received data on channel:', data); // Debugging line
          listenerCallBacks(data); // Call the listener callback
      });
  }
}